import { Card, ListGroup } from "react-bootstrap";
import { IOrder } from "../../../../common/types";

interface ExpandedOrderProps {
  data: IOrder;
}

const ExpandedOrder: React.FC<ExpandedOrderProps> = ({ data }) => {
  return (
    <Card style={{ width: "100%" }}>
      <Card.Body>
        <Card.Title>Dodatne informacije o narudžbi</Card.Title>
        <ListGroup variant="flush">
          <ListGroup.Item>
            <strong>ID Narudžbe:</strong> {data.id}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Datum kreiranja:</strong>{" "}
            {new Date(data.created_at).toLocaleString("hr-HR")}
          </ListGroup.Item>
          {data.paid && data.date_paid && (
            <ListGroup.Item>
              <strong>Datum plaćanja:</strong>{" "}
              {new Date(data.date_paid).toLocaleString("hr-HR")}
            </ListGroup.Item>
          )}
          <ListGroup.Item>
            <strong>Grupa priprema:</strong> {data.course.title}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Iznos:</strong> {data.amount} EUR
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Ime:</strong> {data.customer.first_name}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Prezime:</strong> {data.customer.last_name}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Škola:</strong> {data.customer.profile.school}
          </ListGroup.Item>
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

export default ExpandedOrder;
